import React from 'react'
import check from '../images/CheckSuccess.png';

const PasswordResetSuccess = ({setSuccessStatus, setIsPwReset}) => {

    const backToLogin = (e) => {
        e.preventDefault();
        setSuccessStatus(true);
        // Changing the url to the root without redirecting the browser.
        const newData = null;
        const newUrl = process.env.REACT_APP_IPRS_PHAROS_URL;
        //const newTitle = 'Welcome to IPRS Health - Login'
        window.location.href = newUrl;
       // window.history.pushState(newData, newTitle, newUrl)
    }

    return (
        <div id="passwordChangeSuccessMessage">
            <img 
                src={check}
                className='CheckImageForPasswordChange' 
                alt='check icon'
            />
            <p
                className='passwordChangeSuccessMessageText'
            >
                Your password has been changed successfully.
            </p>
            <button
                className='passwordChangeSuccessMessageButton'
                onClick={(e)=>(backToLogin(e))}
            >
                Back to Login
            </button>
        </div>
    )
    }

export default PasswordResetSuccess